export enum FotaUpdateTypeEnum {
  REGULAR,
  CRITICAL,
  SILENT,
}
